<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<!-- <Button type="primary" size="small" style="margin-right: 5px" @click="add(row.id)">入库</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="delete(row.id)">出库</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="del(row.id)">详情</Button> -->
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				query:{
					commId:'',
					page:0,
					size:10
				},
				total:0,
				loading:false,
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '商品',
						key: 'name',
						render: (h, params) => {
							return h("div",params.row.operComm.name)
						}
					},
					{
						title: '数量',
						key: 'number'
					},
					{
						title: '出库/入库',
						key: 'typeName'
						
					},
					{
						title: '录入时间',
						key: 'createdTime'
					}
				],
				data6: [
				],
				page:{
					page:'',
					size:''
				}
			}
		},
		methods: {
			ret() {//返回上一页
				this.$router.go(-1)
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/com/inventory/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			}
		},
	    components: {
	    	page
	    },
		created() {
			let id=this.$route.query.id
			this.query.commId=id
			this.ajaxPage() 
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/commodity/repertory/details.vue